// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Yen from '../_raw/service/icon_yen.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Yen);
